(() => {
    const polishMobileCart = () => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      const drawer = document.getElementById('CustomCartDrawer');
      if (!drawer) return;

      const checkoutLabel = 'Proceed to secure checkout';
      const checkout = drawer.querySelector('#checkoutBtn');
      if (checkout && checkout.getAttribute('aria-label') !== checkoutLabel) {
        checkout.setAttribute('aria-label', checkoutLabel);
      }
    };

    const start = () => {
      polishMobileCart();
    };

    document.addEventListener('cart:updated', polishMobileCart);
    document.addEventListener('cart:refresh', polishMobileCart);
    document.addEventListener('shopify:section:load', start);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
